module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.26836",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6924",
      "conversations-error-reporting": "static-1.8198",
      "conversations-internal-pub-sub": "static-1.15284",
      "conversations-internal-schema": "static-1.11923",
      "conversations-message-history": "static-1.10426",
      "conversations-test-sdk": "static-1.9739",
      "conversations-visitor-experience-components": "static-1.20199",
      "head-dlb": "static-1.4360",
      "hs-promise-utils": "static-1.4804",
      "hs-test-utils": "static-1.7291",
      "hubspot-dlb": "static-2.1702",
      "HubStyleTokens": "static-2.10795",
      "I18n": "static-7.1442",
      "jasmine-immutable": "static-1.2246",
      "jasmine-runner": "static-1.5703",
      "quartz": "static-1.6073",
      "react-dlb": "static-1.60",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.3818",
      "viral-links-lib": "static-1.6182",
      "visitor-ui-component-library": "static-1.5456",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3847",
      "atom": "static-1.4430",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4071",
      "conversations-infrastructure": "static-1.8219",
      "conversations-prop-types": "static-1.6729",
      "conversations-visibility-tools": "static-1.5051",
      "conversations-visitor-message-history": "static-1.18936",
      "cssUtils": "static-1.588",
      "enviro": "static-4.328",
      "flux-actions": "static-1.285",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3516",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9032",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1-jg-correct-duration-metric.4",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4694",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3656",
      "sanitize-text": "static-1.7432",
      "signup-constants": "static-1.17370",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.474",
      "usage-tracker": "static-1.6728",
      "usage-tracker-core": "static-1.6578",
      "usage-tracker-multi": "static-1.5142",
      "usage-tracker-public": "static-1.6539",
      "visitor-ui-component-library-icons": "static-1.5267",
      "hs-promise-rejection-tracking": "static-1.4750",
      "raven-hubspot": "static-1.5536",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2841",
      "moment": "static-3.26",
      "quartz-core": "static-1.5292",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4158",
      "foundations-components": "static-1.6763",
      "foundations-theming": "static-1.3613",
      "UIComponents": "static-3.7742",
      "cv-backend-services": "static-1.1310",
      "immutable-less": "static-1.3838",
      "conversations-skeleton-state": "static-1.6643",
      "icons": "static-2.593",
      "react-input-autosize": "static-2.17",
      "react-virtualized": "static-2.80",
      "rpc-client-utils": "static-1.3993",
      "ui-images": "static-2.953",
      "permission-components": "static-1.4642",
      "HeadJS": "static-2.617",
      "framer-motion": "static-1.51",
      "hs-test-utils-bend-plugin": "static-1.2402",
      "msw": "static-1.39",
      "testing-library": "static-1.133",
      "i18n-data": "static-1.206",
      "moment-timezone": "static-5.66",
      "jasmine": "static-4.3611",
      "quartz-core-utils": "static-1.2940",
      "signup-ui-url-generator": "static-2.7355",
      "HubStyle": "static-2.11103",
      "sassPrefix": "static-1.139",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5145",
      "dispatcher": "static-1.120",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.689",
      "hub-http-shared-msw-handlers": "static-1.8180",
      "hubspotter-http": "static-1.3957",
      "hubspotter-http-shared-msw-handlers": "static-1.8178",
      "mobile-manifest-mixins": "static-1.388",
      "platform-navigation-bootstrap": "static-1.11744",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.333",
      "hs-story-utils": "static-1.8645",
      "bend-plugin-foundations-components": "static-1.3032",
      "floating-ui": "static-1.39",
      "foundations-theming-specialty": "static-1.1329",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2096",
      "foundations-theming-base": "static-1.2598",
      "ts-schema": "static-1.3483",
      "platform-infra-nav-components": "static-1.7066"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.26836",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6924",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8198",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15284",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11923",
      "conversations-message-history": "/conversations-message-history/static-1.10426",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9739",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20199",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-promise-utils": "/hs-promise-utils/static-1.4804",
      "hs-test-utils": "/hs-test-utils/static-1.7291",
      "hubspot-dlb": "/hubspot-dlb/static-2.1702",
      "HubStyleTokens": "/HubStyleTokens/static-2.10795",
      "I18n": "/I18n/static-7.1442",
      "jasmine-immutable": "/jasmine-immutable/static-1.2246",
      "jasmine-runner": "/jasmine-runner/static-1.5703",
      "quartz": "/quartz/static-1.6073",
      "react-dlb": "/react-dlb/static-1.60",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.3818",
      "viral-links-lib": "/viral-links-lib/static-1.6182",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5456",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3847",
      "atom": "/atom/static-1.4430",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4071",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8219",
      "conversations-prop-types": "/conversations-prop-types/static-1.6729",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5051",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.18936",
      "cssUtils": "/cssUtils/static-1.588",
      "enviro": "/enviro/static-4.328",
      "flux-actions": "/flux-actions/static-1.285",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3516",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9032",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1-jg-correct-duration-metric.4",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4694",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3656",
      "sanitize-text": "/sanitize-text/static-1.7432",
      "signup-constants": "/signup-constants/static-1.17370",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.474",
      "usage-tracker": "/usage-tracker/static-1.6728",
      "usage-tracker-core": "/usage-tracker-core/static-1.6578",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5142",
      "usage-tracker-public": "/usage-tracker-public/static-1.6539",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5267",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2841",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5292",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4158",
      "foundations-components": "/foundations-components/static-1.6763",
      "foundations-theming": "/foundations-theming/static-1.3613",
      "UIComponents": "/UIComponents/static-3.7742",
      "cv-backend-services": "/cv-backend-services/static-1.1310",
      "immutable-less": "/immutable-less/static-1.3838",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6643",
      "icons": "/icons/static-2.593",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-virtualized": "/react-virtualized/static-2.80",
      "rpc-client-utils": "/rpc-client-utils/static-1.3993",
      "ui-images": "/ui-images/static-2.953",
      "permission-components": "/permission-components/static-1.4642",
      "HeadJS": "/HeadJS/static-2.617",
      "framer-motion": "/framer-motion/static-1.51",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2402",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.133",
      "i18n-data": "/i18n-data/static-1.206",
      "moment-timezone": "/moment-timezone/static-5.66",
      "jasmine": "/jasmine/static-4.3611",
      "quartz-core-utils": "/quartz-core-utils/static-1.2940",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7355",
      "HubStyle": "/HubStyle/static-2.11103",
      "sassPrefix": "/sassPrefix/static-1.139",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5145",
      "dispatcher": "/dispatcher/static-1.120",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.689",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8180",
      "hubspotter-http": "/hubspotter-http/static-1.3957",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8178",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.388",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11744",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.333",
      "hs-story-utils": "/hs-story-utils/static-1.8645",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3032",
      "floating-ui": "/floating-ui/static-1.39",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1329",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2096",
      "foundations-theming-base": "/foundations-theming-base/static-1.2598",
      "ts-schema": "/ts-schema/static-1.3483",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7066"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};